/*
  Product card Klarna pill - see the KLARNA FINANCE BADGE note in
  snippets/card-product-unified.liquid. The pill is a native <details>, so it
  opens and closes on its own; this only adds the expected dropdown manners:
  one panel open at a time, and close on an outside tap or Esc.
*/
(function () {
  if (window.jjCardFinanceReady) return;
  window.jjCardFinanceReady = true;

  var OPEN = '.mattress-card__finance[open]';

  function closeAll(except) {
    document.querySelectorAll(OPEN).forEach(function (el) {
      if (el !== except) el.removeAttribute('open');
    });
  }

  // 'toggle' does not bubble, so listen in the capture phase.
  document.addEventListener('toggle', function (event) {
    var el = event.target;
    if (el.matches && el.matches('.mattress-card__finance') && el.open) closeAll(el);
  }, true);

  document.addEventListener('click', function (event) {
    if (!event.target.closest('.mattress-card__finance')) closeAll(null);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeAll(null);
  });
})();
